import React from 'react';
import PropTypes from 'prop-types';

export class ScrollListener extends React.Component {
    lastScrollPosition = 0;
    scrollDistance = 0;
    scrollTicking = false;

    scrollFrame = () => {
        const distance = window.scrollY < 0 ? 0 : window.scrollY - this.lastScrollPosition;

        const scrollDirectionChanged = Math.sign(distance) !== Math.sign(this.scrollDistance);
        if (scrollDirectionChanged) {
            this.scrollDistance = 0;
        }

        this.scrollDistance += distance;

        if (Math.abs(this.scrollDistance) >= this.props.threshold) {
            this.props.onScroll(this.scrollDistance);
            this.scrollDistance = 0;
        }

        this.lastScrollPosition = window.scrollY;
        this.scrollTicking = false;
    };

    onScroll = (event) => {
        if (!this.scrollTicking) {
            this.scrollTicking = true;

            window.requestAnimationFrame(this.scrollFrame);
        }
    };

    static defaultProps = {
        onScroll: () => {},
        threshold: 5
    };

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }

    render() {
        return null;
    }
}

if (process.env.NODE_ENV === 'development') {
    ScrollListener.propTypes = {
        onScroll: PropTypes.func.isRequired,
        threshold: PropTypes.number
    };
}

export default ScrollListener;
